import { dag } from '@hyper-hyper-space/hhs3_dag';
import { extractCreatePayloadType } from '@hyper-hyper-space/hhs3_mvt';
import { encode, decode } from './codec.js';
const DEFAULT_TIMEOUT_MS = 10000;
const RETRY_INTERVAL_MS = 200;
export function fetchInit(objectId, swarms, hashSuite, timeoutMs = DEFAULT_TIMEOUT_MS) {
    return new Promise((resolve, reject) => {
        let settled = false;
        const retryTimers = [];
        const timer = setTimeout(() => {
            if (settled)
                return;
            settled = true;
            cleanup();
            reject(new Error(`fetchInit timed out after ${timeoutMs}ms for object ${objectId}`));
        }, timeoutMs);
        function cleanup() {
            clearTimeout(timer);
            for (const t of retryTimers)
                clearInterval(t);
        }
        function finish(createPayload) {
            if (settled)
                return;
            settled = true;
            cleanup();
            resolve(createPayload);
        }
        function fail(reason) {
            if (settled)
                return;
            settled = true;
            cleanup();
            reject(new Error(reason));
        }
        function handlePeer(sp) {
            if (settled)
                return;
            const request = { type: 'init-request', objectId };
            function sendRequest() {
                if (settled || !sp.channel.open)
                    return;
                try {
                    sp.channel.send(encode(request));
                }
                catch ( /* channel may close */_a) { /* channel may close */ }
            }
            sendRequest();
            const retryTimer = setInterval(sendRequest, RETRY_INTERVAL_MS);
            retryTimers.push(retryTimer);
            sp.channel.onMessage((data) => {
                if (settled)
                    return;
                let msg;
                try {
                    msg = decode(data);
                }
                catch (_a) {
                    return;
                }
                if (msg.type !== 'init-response' || msg.objectId !== objectId)
                    return;
                const entry = dag.createEntry(msg.createPayload, {}, dag.position(), hashSuite);
                if (entry.hash !== objectId) {
                    fail(`Creation payload hash mismatch: expected ${objectId}, got ${entry.hash}`);
                    return;
                }
                const payloadType = extractCreatePayloadType(msg.createPayload);
                if (payloadType === undefined) {
                    fail('Creation payload missing type');
                    return;
                }
                finish(msg.createPayload);
            });
        }
        for (const swarm of swarms) {
            for (const existing of swarm.peers()) {
                handlePeer(existing);
            }
            swarm.onPeerJoin(handlePeer);
        }
    });
}
